import _ from 'underscore';
import { guid } from '../base';
import { log, convertToJSON } from './base';
import './strophe.ping';

const { Strophe, $pres, $msg, $iq } = window;
export const pluginName = 'im_colleague';

Strophe.addConnectionPlugin(pluginName, {
    _connection: null,
    _user: null,
    _defaultNick: '',
    _msgHandlers: [],
    _presHandlers: [],
    init(conn) {
        this._connection = conn;
        conn.rawInput = this.rawInput.bind(this);
        conn.rawOutput = this.rawOutput.bind(this);
        Strophe.log = this.log.bind(this);
    },
    rawInput(data) {
        if (/^<(presence|message)/.test(data) || /error/i.test(data)) {
            log('recv', data);
        }
    },
    rawOutput(data) {
        if (/^<(presence|message)/.test(data)) {
            log('send', data);
        }
    },
    log(level, msg) {
        if (level < 3) {
            if (!/error|disconnect/i.test(msg)) {
                return;
            }
        }

        let type;
        let LogLevel = Strophe.LogLevel;
        for (var k in LogLevel) {
            if (LogLevel[k] === level) {
                type = k.toLowerCase();
            }
        }
        log(type, msg);
    },
    ping() { //尽早清除僵尸用户，提升消息送达率
        let plugin = this._connection.ping;
        let status = this.connectStatus;

        plugin.clearPingHandler();
        plugin.ping(this._user.jid, () => {}, () => {}, 30000);
        plugin.addPingHandler(function(ping) {
            try {
                status.connected && plugin.pong(ping);
            } catch (ex) {}

            return true;
        });
    },
    setDefaultNick(nick) {
        this._defaultNick = nick;
    },
    toNick(jid, nick) {
        return jid + '/' + Strophe.escapeNode(nick || this._defaultNick);
    },
    /**
        options: {
            error: [Function]    An error has occurred
            connecting: [Function]   The connection is currently being made
            connfail: [Function] The connection attempt failed
            authenticating: [Function]   The connection is authenticating
            authfail: [Function] The authentication attempt failed
            connected: [Function]    The connection has succeeded
            disconnected: [Function] The connection has been terminated
            disconnecting: [Function]    The connection is currently being terminated
            attached: [Function] The connection has been attached
        }
    */
    connect(user, options) {
        this._user = user;
        options = options || {};

        let username = this.toNick(user.jid, user.resource);
        this._connection.connect(username, user.password, function(status) {
            var statusTxt = '';
            for (var k in Strophe.Status) {
                if (status === Strophe.Status[k]) {
                    statusTxt = k.toLowerCase();
                    break;
                }
            }
            log('status', statusTxt);

            this.connectStatus = {
                [statusTxt]: true
            };

            if (statusTxt === "connected") {
                this.destory();
                this.sendPresence(); //通知ejabberd
                this.sendPresence({ //通知所有人
                    attributes: {
                        to: this.toNick(user.company_jid)
                    },
                    children: {
                        name: 'body',
                        value: {
                            user_jid: user.jid,
                            status: 'online'
                        }
                    }
                });
                this.ping();
            }

            options[statusTxt] && options[statusTxt]();
            options['always'] && options['always'](statusTxt);
        }.bind(this));
    },
    /**
        cfg: {
            flush
            sync
        }
    */
    disconnect(cfg) {
        cfg = cfg || {};

        var conn = this._connection;
        cfg.flush && conn.flush();
        cfg.sync && (conn.options.sync = true);
        conn.disconnect();
    },
    appendChildren(xml, data) {
        if (!xml || !data) return;

        var children = _.isArray(data.children) ? data.children : [data.children];
        _.each(children, function(node, idx) {
            if (node) {
                if (node.name) {
                    idx && xml.up();
                    xml = xml.c(node.name, node.attributes || {}).t(_.isObject(node.value) ? JSON.stringify(node.value) : node.value || '');
                }

                if (node.children) {
                    this.appendChildren(xml, node);
                }
            }
        }.bind(this));
    },
    /** 发送消息
        data: {
            attributes: {},
            children: [{
                name: '',
                value: '',
                attributes: {}
            }]
        }
    */
    sendMessage(data) {
        let attrs = data.attributes || {};
        let type = attrs.type || 'chat';
        let children = data.children || [];

        attrs.type = type === 'group' ? 'groupchat' : type;

        if (attrs.type === 'groupchat') {
            children = _.isArray(children) ? children : [children];
            let body = _.find(children, { name: 'body' });
            body && (body.xmlns = Strophe.NS.CLIENT);
        }

        var msg = $msg(_.extend({
            type: 'chat', //groupchat
            from: this._user.jid
        }, attrs));

        this.appendChildren(msg, data);
        this._connection.send(msg.tree());
    },
    /** 发送状态
        data: {
            attributes: {},
            children: [{
                name: '',
                value: '',
                attributes: {}
            }]
        }
    */
    sendPresence(data = {}) {
        var presence = $pres(_.extend({
            from: this._user.jid
        }, data.attributes));
        this.appendChildren(presence, data);
        this._connection.send(presence.tree());
    },
    /** 发送IQ
        data: {
            attributes: {},
            children: [{
                name: '',
                value: '',
                attributes: {}
            }]
        }
    */
    sendIQ(data = {}) {
        var iq = $iq(_.extend({
            id: guid(),
            from: this._user.jid
        }, data.attributes));
        this.appendChildren(iq, data);

        log('send', iq.toString());

        return new Promise(function(resolve, reject) {
            this._connection.sendIQ(iq, (xml) => {
                log('recv', xml);
                try {
                    resolve(convertToJSON(xml));
                } catch (ex) {
                    reject(xml);
                }
            }, reject);
        }.bind(this));
    },
    onMessage(cb) { //接受消息
        var handler = function(xml) {
            try {
                cb(convertToJSON(xml));
            } catch (ex) {
                log('excetion', ex, xml);
            }
            return true;
        }.bind(this);

        this._msgHandlers.push(handler)
        this._connection.addHandler(handler, null, 'message', null, null, null);

        return true;
    },
    onPresence(cb) { //接受状态
        var handler = function(xml) {
            try {
                cb(convertToJSON(xml));
            } catch (ex) {
                log('excetion', ex, xml);
            }
            return true;
        }.bind(this);

        this._presHandlers.push(handler)
        this._connection.addHandler(handler, null, 'presence');

        return true;
    },
    joinRoom({ to }) {
        return this.sendPresence({
            attributes: {
                to: this.toNick(to)
            },
            children: {
                name: 'x',
                attributes: {
                    xmlns: Strophe.NS.MUC
                }
            }
        });
    },
    subscribeRoom({ to }) {
        return this.sendIQ({
            attributes: {
                type: 'set',
                to: this.toNick(to)
            },
            children: {
                name: 'subscribe',
                attributes: {
                    xmlns: 'urn:xmpp:mucsub:0'
                },
                children: [{
                    name: 'event',
                    attributes: {
                        node: 'urn:xmpp:mucsub:nodes:messages'
                    }
                }]
            }
        });
    },
    destory() {
        let arr = this._msgHandlers.concat(this._presHandlers);
        for (var i = arr.length - 1; i >= 0; i--) {
            this._connection.deleteHandler(arr[i]);
        }

        this._msgHandlers.length = 0;
        this._presHandlers.length = 0;
    }
});


// WEBPACK FOOTER //
// ./src/utils/webIM/strophe.main.js